import { ParkEventsPage } from "./ParkEventsPage";
import { EVENT_TYPE } from "./types/EVENT_TYPE";

export const CollaborateEventPage = (props: { pageTitle: string }) => {
  return <ParkEventsPage pageTitle={props.pageTitle} eventType={EVENT_TYPE.Collaborate} />;
};
